<template>
  <v-row justify="center">
    <v-col cols="12" md="12">
      <div class="d-flex justify-center align-center">
        <v-img v-if="user.avatar && !isAdding" :src="user.avatar.url" max-width="300"></v-img>
      </div>
      <div class="mx-auto mt-1" style="max-width: 300px">
        <FullWidthButton v-if="!user.avatar || !isAdding" @click="toggleAvatarUpload">
          Change Profile Image
        </FullWidthButton>
      </div>
    </v-col>
  </v-row>
  <v-row v-if="!user.avatar || isAdding">
    <v-col cols="12" md="12">
      <v-form>
        <v-file-input v-model="file" label="Choose a file" accept="image/*"></v-file-input>
        <v-row>
          <v-col>
            <FullSecondaryButton @click="isAdding = false">Cancel</FullSecondaryButton>
          </v-col>
          <v-col>
            <FullWidthButton :disabled="!file" @click="uploadAvatar">Upload</FullWidthButton>
          </v-col>
        </v-row>
        <v-progress-linear
          v-if="uploadAvatarProgress > 0"
          v-model="uploadAvatarProgress"
          height="10"
          color="blue"></v-progress-linear>
      </v-form>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import { saveAvatar } from '@/controllers/uploadController.js';
import { ref, toRef } from 'vue';
import { IUserDTO, UserDTO } from '@/dtos';
import { useAuthStore, useUserStore } from '@/stores';
interface Props {
  user: IUserDTO;
  isAdmin: boolean;
}
const props = defineProps<Props>();
const user = toRef(props, 'user', new UserDTO());
const isAdmin = toRef(props, 'isAdmin', false);
const userStore = useUserStore();
const authStore = useAuthStore();

const emit = defineEmits(['avatarUpdatedCompleted', 'snack']);

const isAdding = ref<boolean>(false);
const file = ref<File>();
const uploadAvatarProgress = ref<number>(0);
const uploadAvatarCompleted = ref<boolean>(false);

const toggleAvatarUpload = async () => {
  file.value = undefined;
  uploadAvatarProgress.value = 0;
  uploadAvatarCompleted.value = false;
  isAdding.value = !isAdding.value;
};

const uploadAvatar = async () => {
  if (!file.value) {
    emit('snack', 'Avatar', 'error', 'No file selected');
    return;
  }

  try {
    const updateProgress = (progress: number) => {
      if (progress >= 100) {
        uploadAvatarProgress.value = 0;
      } else {
        uploadAvatarProgress.value = progress;
      }
    };

    if (isAdmin.value && authStore.me && user.value.id != authStore.me.id) {
      //TODO add admin save avatar method.
    } else {
      await saveAvatar(file.value, updateProgress);
      userStore.refetchUser();
    }
    emit('snack', 'Avatar', 'success:update');
    setTimeout(() => {
      isAdding.value = false;
      emit('avatarUpdatedCompleted', true);
    }, 1000);
  } catch (error: unknown) {
    const msg = error as string;
    emit('snack', 'Avatar', 'error', `Upload failed: ${msg}`);
    console.error(error);
  }
};
</script>
